import VideoListing from '../components/VideoListing/VideoListing'
import { useEffect, useState } from 'react'
import { fetchVideos } from '../utils/api'

function Home () {
  const [videos, setVideos] = useState([])

  useEffect(() => {
    fetchVideos().then(data => setVideos(data.items))
  }, [])

  return (
    <>
      {videos.length !== 0 ? (
        <VideoListing videos={videos} setVideos={setVideos}/>

      ) : (
        <p style={{
          display: 'flex',
          minHeight: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '2rem',
        }}>Loading videos...</p>
      )}
    </>
  )
}

export default Home